import React from 'react';

import HasSeriesRecording from 'assets/images/svgs/Recording/ico_record_all.svg';
import HasSeriesRecordingBlack from 'assets/images/svgs/Recording/ico_record_all_black.svg';

type Props = { highlighted: boolean; size: number };

function RecordedSeriesRecording({ highlighted, size }: Props) {
    return highlighted ? (
        <HasSeriesRecordingBlack width={size} height={size} />
    ) : (
        <HasSeriesRecording width={size} height={size} />
    );
}

export default RecordedSeriesRecording;
